import {
  Notice as SharedNotice,
  NoticeStatus as SharedNoticeStatus,
  NoticeType as SharedNoticeType,
  NoticeContextType as SharedNoticeContextType,
  NoticeErrorLevel as SharedNoticeErrorLevel,
} from "shared/dist/types/Notice";
import {
  NOTICE_STATUSES as SharedNoticeStatuses,
  NOTICE_TYPES as SharedNoticeTypes,
  NOTICE_CONTEXT_TYPES as SharedNoticeContextTypes,
  NOTICE_ERROR_LEVELS as SharedNoticeErrorLevels,
} from "shared/dist/types/Notice";

export type NoticeStatus = SharedNoticeStatus;
export type NoticeType = SharedNoticeType;
export type NoticeContextType = SharedNoticeContextType;
export type NoticeErrorLevel = SharedNoticeErrorLevel;

export const NOTICE_STATUSES = SharedNoticeStatuses;
export const NOTICE_TYPES = SharedNoticeTypes;
export const NOTICE_CONTEXT_TYPES = SharedNoticeContextTypes;
export const NOTICE_ERROR_LEVELS = SharedNoticeErrorLevels;

export default interface Notice extends SharedNotice {}